module.exports = __webpack_public_path__ + "static/media/spreadsheet.9c9edc5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/spreadsheet.svg
// module id = 1338
// module chunks = 0